export default __webpack_public_path__ + "static/media/gi.51e90a70.svg";